import globalI18n from '@/plugins/i18n.js'

export const useI18nUtils = (i18n = null) => {
  i18n ??= globalI18n
  const { t, te, locale, fallbackLocale, availableLocales } = i18n.global

  let partnerCode = null

  function translate(paths, options = {}) {
    let keyPaths
    let translation = null
    let locales = [locale.value, fallbackLocale.value]

    if (options.count == null) options.count = 1
    if (Array.isArray(paths)) keyPaths = paths
    else keyPaths = [paths]

    // Try partner-specific translations first
    translation = _translateWithPartnerOverride(keyPaths, locales, options)
    translation ??= _translateLocales(keyPaths, locales, options)
    translation ??= _keyPathsDisplay(keyPaths)

    return translation
  }

  function _translateWithPartnerOverride(keyPaths, locales, options) {
    try {
      if (!partnerCode) return null

      // Create partner-specific key paths
      const partnerKeyPaths = keyPaths.map(path => {
        return `partners.${partnerCode}.${path}`
      })

      return _translateLocales(partnerKeyPaths, locales, options)
    } catch (error) {
      return null
    }
  }

  function setPartnerCode(newPartnerCode) {
    partnerCode = newPartnerCode
  }
  
  function setLocale(newLocale) {
    // Use a ! to force vue-i18n to not replace the locale with an alternative. E.g en -> en-US
    // If the newLocale already has a !, remove it
    newLocale = newLocale.replace(/!/g, '')
    locale.value = `${newLocale}!`
  }

  function getLocale() {
    let currentLocale = locale.value
    // Internally we use ! versions of locales, but we will strip this when presenting the locale
    currentLocale = currentLocale.replace(/!/g, '')
    return currentLocale
  }

  function _translateLocales(keyPaths, locales, options) {
    let translation = null

    for (let currentLocale of locales) {
      for (let currentPath of keyPaths) {
        options.locale = currentLocale
        translation ??= _getTranslation(currentPath, options)
      }

      if (translation != null) break
    }

    return translation
  }

  function _getTranslation(key, options) {
    // `te` doesn't respect ! locales, so we need to strip them
    let safeLocale = options.locale.replace(/!/g, '')
    if (te(key, safeLocale)) return t(key, options)
    else return null
  }

  function _keyPathsDisplay(keyPaths) {
    let displayValue = []

    for (let currentPath of keyPaths) {
      displayValue.push(currentPath)
    }

    let keyPathsDisplay = displayValue.join(" → ")
    return `«${keyPathsDisplay}»`
  }

  return {
    t: translate,
    setPartnerCode,
    setLocale,
    getLocale,
    availableLocales
  }

}